<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="form-base__title">
          {{ title }}
        </div>
      </v-col>

      <v-col cols="4">
        <v-text-field
          v-model="v.assigneeLastName.$model"
          :errorMessages="getValidationErrorText(v.assigneeLastName)"
          label="Фамилия"
          outlined
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="v.assigneeName.$model"
          :errorMessages="getValidationErrorText(v.assigneeName)"
          label="Имя"
          outlined
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="v.assigneePatronymic.$model"
          :errorMessages="getValidationErrorText(v.assigneePatronymic)"
          label="Отчество (при наличии)"
          outlined
        />
      </v-col>

      <v-col cols="12">
        <v-text-field
          v-model="v.assigneeSnils.$model"
          :errorMessages="getValidationErrorText(v.assigneeSnils)"
          label="СНИЛС"
          v-mask="['###-###-### ##']"
          outlined
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators';

import {
  getValidationErrorText,
  MAX_LENGTH,
  MinLength,
  PERSON_NAME,
  SNILS_ROD,
} from '@/utils/validate';

export const assigneeModel = {
  assigneeLastName: '',
  assigneeName: '',
  assigneePatronymic: '',
  assigneeSnils: '',
};

export const assigneeValidation = {
  assigneeLastName: {
    required,
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  assigneeName: {
    required,
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  assigneePatronymic: {
    maxLength: maxLength(MAX_LENGTH),
    PERSON_NAME,
  },
  assigneeSnils: {
    required,
    minLength: minLength(MinLength.SNILS),
    SNILS: SNILS_ROD,
  },
};

export default {
  name: 'Assignee',
  props: {
    v: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    getValidationErrorText,
  }),
};
</script>
